import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { IMyTeam } from '../../myTeam/types/myTeam';
import './HomeTeamCard.scss';

const HomeTeamCard: React.FC<{ team: IMyTeam }> = ({ team }) => {
  const navigate = useNavigate();

  const winCount = team.winMatchesCount ?? 0;
  const lossCount = team.lossMatchesCount ?? 0;
  const totalPlayed = winCount + lossCount;
  const winRate = totalPlayed > 0 ? Math.round((winCount / totalPlayed) * 100) : null;

  const hasWinRate = winRate != null && totalPlayed > 0;
  const hasRecentForm = team.recentForm != null && team.recentForm.length > 0;

  const handleClick = () => {
    navigate(`/my-team/${team.teamId}`, { state: { team } });
  };

  return (
    <div
      className="logged-home-team-card"
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      role="button"
      tabIndex={0}
    >
      <div className="logged-home-team-card-header">
        {team.teamLogo ? (
          <img
            src={team.teamLogo}
            alt={team.teamName}
            className="logged-home-team-card-logo"
          />
        ) : (
          <div className="logged-home-team-card-logo-placeholder" aria-hidden />
        )}
        <div className="logged-home-team-card-info">
          <span className="logged-home-team-card-name">{team.teamName}</span>
          <span className="logged-home-team-card-role">{team.role ?? 'Player'}</span>
        </div>
      </div>
      <div className="logged-home-team-card-divider" />
      <div className="logged-home-team-card-stats">
        <div className="logged-home-team-card-stat">
          <span className="stat-label">Players</span>
          <span className="stat-value">{team.totalPlayers ?? 0}</span>
        </div>
        {hasWinRate && (
          <div className="logged-home-team-card-stat">
            <span className="stat-label">Win Rate</span>
            <span className="stat-value stat-value--green">{winRate}%</span>
          </div>
        )}
      </div>
      {hasRecentForm && (
        <div className="logged-home-team-card-form">
          <span className="form-label">Recent Form</span>
          <div className="form-squares">
            {team.recentForm!.map((r, i) => (
              <span
                key={i}
                className={`form-square form-square--${r.toLowerCase()}`}
              >
                {r}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeTeamCard;
